const segmentGradients = {
  green: ['rgb(65, 202, 59)', 'rgb(77, 168, 31)'],
  red: ['rgb(210, 28, 0)', 'rgb(172, 31, 2)'],
  yellow: ['#f3df06', '#eec718'],
  blue: ['#0068ff', '#0054d3'],
  lightBlue: ['rgb(147 190 255)', 'rgb(80 149 255)']
};

export default segmentGradients;